/** 1-based stop label for route waypoints (1, 2, 3, …). */
export const getStopNumber = (index) => String(index + 1);
